import React from "react"
import cx from "classnames"

export const Container = ({ children }) => {
  return <div className="w-full flex justify-center">
    <div className="max-w-xl w-full">
      {children}
    </div>
  </div>
}

export const Section = ({ children, className = "", grid = false, ...props }) => {
  return <section className={cx(className, "px-container-mobile md:px-container-desktop", { "grid grid-cols-6 md:grid-cols-12 gap-3 md:gap-6": grid })} {...props}>
    {children}
  </section>
}